function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGitlab({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_gitlab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "16 28.896 16 28.896 21.156 13.029 10.844 13.029 16 28.896",
    style: {
      fill: "#e24329"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16 28.896 10.844 13.029 3.619 13.029 16 28.896",
    style: {
      fill: "#fc6d26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.619,13.029h0L2.052,17.851a1.067,1.067,0,0,0,.388,1.193L16,28.9,3.619,13.029Z",
    style: {
      fill: "#fca326"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.619,13.029h7.225L7.739,3.473a.534.534,0,0,0-1.015,0L3.619,13.029Z",
    style: {
      fill: "#e24329"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16 28.896 21.156 13.029 28.381 13.029 16 28.896",
    style: {
      fill: "#fc6d26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.381,13.029h0l1.567,4.822a1.067,1.067,0,0,1-.388,1.193L16,28.9,28.381,13.029Z",
    style: {
      fill: "#fca326"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.381,13.029H21.156l3.105-9.557a.534.534,0,0,1,1.015,0l3.105,9.557Z",
    style: {
      fill: "#e24329"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlab);
export default __webpack_public_path__ + "static/media/gitlab.17219b33c77b4216305d00d15cde4d2b.svg";
export { ForwardRef as ReactComponent };